<h2>Password Basic Examples</h2>

<div class="input-grid">
	<div class="input-column">
		<span class="label">Password solo</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Enter password..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Enter password...'})" />
	</div>

	<div class="input-column">
		<span class="label">Con label</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Enter your password..."
			label="Password"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Enter your password...', label: 'Password'})" />
	</div>

	<div class="input-column">
		<span class="label">Con helper text</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Enter password..."
			label="Password"
			helperText="Must be at least 8 characters"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Enter password...', label: 'Password', helperText: 'Must be at least 8 characters'})" />
	</div>
</div>

<h2>Password with Icon</h2>

<div class="input-grid">
	<div class="input-column">
		<span class="label">Icono a la izquierda</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Enter password..."
			label="Password"
			icon="lock"
			iconPosition="left"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Enter password...', label: 'Password', icon: 'lock', iconPosition: 'left'})" />
	</div>

	<div class="input-column">
		<span class="label">Password completo</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Enter your password..."
			label="Password"
			icon="lock"
			iconPosition="left"
			helperText="Use a strong password"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Enter your password...', label: 'Password', icon: 'lock', iconPosition: 'left', helperText: 'Use a strong password'})" />
	</div>
</div>

<h2>Password Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Large password..."
			label="Large Password"
			icon="lock"
			iconPosition="left"
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Large password...', label: 'Large Password', icon: 'lock', iconPosition: 'left', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Medium password..."
			label="Medium Password"
			icon="lock"
			iconPosition="left"
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Medium password...', label: 'Medium Password', icon: 'lock', iconPosition: 'left', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Small password..."
			label="Small Password"
			icon="lock"
			iconPosition="left"
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Small password...', label: 'Small Password', icon: 'lock', iconPosition: 'left', size: 'small'})" />
	</div>
</div>

<h2>Password States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Normal password..."
			label="Normal State"
			icon="lock"
			iconPosition="left"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Normal password...', label: 'Normal State', icon: 'lock', iconPosition: 'left'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-password
			[formControl]="disabledControl"
			placeholder="Disabled password..."
			label="Disabled State"
			icon="lock"
			iconPosition="left"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledControl', placeholder: 'Disabled password...', label: 'Disabled State', icon: 'lock', iconPosition: 'left', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Error password..."
			label="Error State"
			icon="lock"
			iconPosition="left"
			[error]="true"
			errorMessage="Password is required"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Error password...', label: 'Error State', icon: 'lock', iconPosition: 'left', error: true, errorMessage: 'Password is required'})" />
	</div>
</div>

<h2>Password Sizes Comparison (without icons)</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Large..."
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Large...', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Medium..."
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Medium...', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-password
			[formControl]="passwordControl"
			placeholder="Small..."
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'passwordControl', placeholder: 'Small...', size: 'small'})" />
	</div>
</div>
